module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-SemiBold.woff2?b5f0f109bc88052d4000c58ca615671d";